import { Suit } from './Suit';

export class Card {
    suit: Suit;
    number?: number;
    played?: number;
    player?: number = 0;
    winner?: number;

    constructor (suit: Suit, number?: number, player?: number) {
        this.suit = suit;
        this.number = number;
        this.player = player;
    }
}


// WEBPACK FOOTER //
// ./src/playing-cards/Card.ts